import { ensureTrailingSlash } from '@otovo/shared/components/BusinessUnitLogo';
import { useGlobalConfig } from '@otovo/shared/hooks/configContext';
import Link from 'next/link';
import { ComponentProps } from 'react';
import OtovoLogo from '../icons/Logo';

type Props = {
  linkToRoot?: boolean;
  variant?: ComponentProps<typeof OtovoLogo>['variant'];
  label?: string;
};

const NavbarLogo = ({ linkToRoot = true, variant = 'blue', label }: Props) => {
  const { STOREFRONT_URL } = useGlobalConfig();
  function renderLogo() {
    return (
      <>
        {!!label && <span className="sr-only">{label}</span>}
        <OtovoLogo variant={variant} aria-hidden="true" focusable="false" />
      </>
    );
  }

  if (linkToRoot) {
    return (
      <Link href={ensureTrailingSlash(STOREFRONT_URL)}>{renderLogo()}</Link>
    );
  }

  return renderLogo();
};

export default NavbarLogo;
